import { ContentfulComponentCard } from 'graphqlTypes';
import { FC } from 'react';

// Quarks
import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';
import Link from 'quarks/Link';

const headingWrapCSS = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

type MinimalCardProps = {
  card: ContentfulComponentCard;
  isSlider?: boolean;
};

const MinimalCard: FC<MinimalCardProps> = ({ card, isSlider }) => (
  <Flex
    data-testid="card"
    key={`item ${card.id}`}
    width="100%"
    flex="1 1 auto"
    {...(!isSlider && { paddingAll: 10 })}
    {...(!isSlider && { sm: { width: '50%' } })}
    {...(!isSlider && { lg: { flex: 'none', width: '33%' } })}
  >
    <Link href={card?.callToAction?.link || card?.link} textDecoration="none" width="100%">
      {card?.heading && (
        <Flex
          width="100%"
          height="100%"
          flexDirection="column"
          borderRadius="12px"
          overflowX="hidden"
          overflowY="hidden"
          border="1px solid"
          borderColor="gray-200"
          hover={{ boxShadow: 'xxl' }}
          transition="200ms ease-in-out"
          backgroundColor="common-white"
        >
          <Flex
            position="relative"
            flexDirection="row"
            justifyContent="space-between"
            gap="12px"
            height="100%"
            maxHeight="fit-content"
            paddingAll={24}
          >
            <Flex flexDirection="column" gap="12px" justifyContent="center">
              <Heading as="h4" textStyle="h5" data-cy="title" textColor="gray-900" css={headingWrapCSS}>
                {card.heading}
              </Heading>
            </Flex>
            {(card?.callToAction?.link || card?.link) && (
              <Flex gap="4px" alignItems="center">
                <Icon id="arrow-right" fill={color.gray[900]} size={20} />
              </Flex>
            )}
          </Flex>
        </Flex>
      )}
    </Link>
  </Flex>
);

export default MinimalCard;
